(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hz-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('testimonial-text-clamp')) {
  class TestimonialTextClamp extends HTMLElement {
    constructor() {
      super();
      this.lines = 3;
      this._onResize = this.onResize.bind(this);
      window.initScriptOnDemand(this, this.init.bind(this));
    }

    init() {
      this.content = this.querySelector('.testimonial-text-clamp__content');
      this.button = this.querySelector('.testimonial-text-clamp__toggle');
      if (!this.content || !this.button) return;

      this.button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      }.bind(this));

      this.applyCollapsedHeight();
      this.updateButtonVisibility();

      window.addEventListener('resize', this._onResize);
      window.addEventListener('resizeend', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('resizeend', this._onResize);
    }

    onResize() {
      if (this.classList.contains('is-expanded')) return;
      this.applyCollapsedHeight();
      this.updateButtonVisibility();
    }

    getLineHeight() {
      var style = window.getComputedStyle(this.content);
      var lineHeight = parseFloat(style.lineHeight);
      if (Number.isNaN(lineHeight)) {
        lineHeight = parseFloat(style.fontSize) * 1.5;
      }
      return lineHeight;
    }

    getCollapsedHeight() {
      return this.getLineHeight() * this.lines;
    }

    applyCollapsedHeight() {
      var height = this.getCollapsedHeight();
      this.style.setProperty('--testimonial-clamp-height', height + 'px');
      this.content.style.maxHeight = height + 'px';
      this.content.style.minHeight = height + 'px';
    }

    updateButtonVisibility() {
      if (this.classList.contains('is-expanded')) {
        this.button.hidden = false;
        return;
      }

      var needsToggle = this.content.scrollHeight > this.getCollapsedHeight() + 1;
      this.button.hidden = !needsToggle;
      this.classList.toggle('is-clamped', needsToggle);
    }

    toggle() {
      if (this.classList.contains('is-expanded')) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.classList.add('is-expanded');
      this.content.style.maxHeight = 'none';
      this.content.style.minHeight = '0';
      this.button.setAttribute('aria-expanded', 'true');
      this.button.textContent = this.button.dataset.labelLess || 'Show less';
      this.button.hidden = false;
    }

    collapse() {
      this.classList.remove('is-expanded');
      this.applyCollapsedHeight();
      this.button.setAttribute('aria-expanded', 'false');
      this.button.textContent = this.button.dataset.labelMore || 'Show more';
      this.updateButtonVisibility();
    }
  }

  customElements.define('testimonial-text-clamp', TestimonialTextClamp);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
